import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=083e764a&scoped=true&"
import script from "./ResetPass.vue?vue&type=script&lang=js&"
export * from "./ResetPass.vue?vue&type=script&lang=js&"
import style0 from "./ResetPass.vue?vue&type=style&index=0&id=083e764a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e764a",
  null
  
)

export default component.exports